import { render, staticRenderFns } from "./Afastamentos.vue?vue&type=template&id=5e101b27&lang=pug&"
import script from "./Afastamentos.vue?vue&type=script&lang=js&"
export * from "./Afastamentos.vue?vue&type=script&lang=js&"
import style0 from "./usuarios.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports